/** 穴埋めカードの表示と採点の文言（card-schema.md §3.2、judge.md §4.1） */
import type { JudgeResult } from '../../lib/judge';
import type { GradeResult } from '../types';

export type TemplateSegment = { kind: 'text'; text: string } | { kind: 'blank'; id: number };

/** template を文字列と空欄 ⟦n⟧ に分ける。末尾の改行は表示しない */
export function templateSegments(template: string): TemplateSegment[] {
  const out: TemplateSegment[] = [];
  const re = /⟦([1-9])⟧/g;
  const src = template.replace(/\n+$/, '');
  let last = 0;
  for (const m of src.matchAll(re)) {
    if (m.index > last) out.push({ kind: 'text', text: src.slice(last, m.index) });
    out.push({ kind: 'blank', id: Number(m[1]) });
    last = m.index + m[0].length;
  }
  if (last < src.length) out.push({ kind: 'text', text: src.slice(last) });
  return out;
}

const AGAIN = 'このカードはあとでもう一度出ます。';

/** 照合だけで外れたとき（grading: client） */
export function localMismatch(wrongIds: readonly number[]): GradeResult {
  const names = wrongIds.map((id) => `空欄 ${id}`).join('、');
  return { verdict: 'WA', message: `${names} が一致しませんでした。${AGAIN}` };
}

/** 照合で外れ、実行して判定したとき（grading: client-then-server） */
export function sandboxResult(judge: JudgeResult, expected: string): GradeResult {
  const c = judge.cases[0];
  switch (judge.overall) {
    case 'AC':
      return {
        verdict: 'AC',
        message: '答えの一覧にない書き方ですが、実行すると期待する出力と一致しました。',
      };
    case 'CE':
      return { verdict: 'CE', message: `埋めたコードはコンパイルできませんでした。${AGAIN}` };
    case 'TLE':
      return { verdict: 'TLE', message: `埋めたコードは 3 秒以内に終わりませんでした。${AGAIN}` };
    case 'RE':
      return {
        verdict: 'RE',
        message: `埋めたコードは実行の途中で止まりました。${AGAIN}`,
        ...(c ? { stderr: c.stderr } : {}),
      };
    default:
      return {
        verdict: 'WA',
        message:
          '埋めたコードを実行すると、出力が一致しませんでした。期待する出力と並べて表示します。',
        expected,
        actual: c?.stdout ?? '',
      };
  }
}
